import React, { useState } from 'react'

import { CollectionAsset, CollectionInfoBoxDescription } from 'meta/pages/collection'

import Images from './Images'
import ProgressBar from './ProgressBar'

interface Props {
  images: CollectionAsset[]
  descData: CollectionInfoBoxDescription
}

const Gallery: React.FC<Props> = (props) => {
  const { images, descData } = props

  const [visibleItem, setVisibleItem] = useState<number>(0)

  return (
    <>
      <Images setVisible={setVisibleItem} images={images} descData={descData} />
      <ProgressBar visible={visibleItem} total={images.length} />
    </>
  )
}

export default Gallery
